/* Family Flips email sign-up slide-in (Oct 2026). Native Shopify customer form; no third-party code. */
(function () {
  var box = document.getElementById('FFSignup');
  if (!box) return;
  var KEY = 'ff_signup_v1';
  var DAY = 864e5;
  var form = box.querySelector('form');
  var input = box.querySelector('#FFSignup-email');
  var msg = box.querySelector('#FFSignup-msg');
  var closeBtn = box.querySelector('[data-ff-signup-close]');
  var lastFocus = null;
  var shown = false;
  var timer = null;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function write(state) {
    try { localStorage.setItem(KEY, JSON.stringify({ s: state, t: Date.now() })); } catch (e) {}
  }
  function suppressed() {
    var r = read();
    if (!r || !r.t) return false;
    var days = r.s === 'subscribed' ? 365 : 30;
    return Date.now() - r.t < days * DAY;
  }

  // Phones: lift floating widgets (Shopify Inbox chat button, Google rating badge) above the open slide-in so nothing covers it.
  function setLift() {
    var top = box.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--ff-signup-lift', Math.max(0, Math.round(window.innerHeight - top + 8)) + 'px');
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); hide(true); }
  }

  function show(opts) {
    if (shown) return;
    shown = true;
    opts = opts || {};
    if (!opts.keepState) write('shown');
    cleanupTriggers();
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('ff-signup-open');
    setLift();
    window.addEventListener('resize', setLift);
    box.classList.add('ff-signup--enter');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { box.classList.remove('ff-signup--enter'); });
    });
    document.addEventListener('keydown', onKey);
    var a = document.activeElement;
    var typing = a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT' || a.isContentEditable);
    if (!typing) {
      try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); }
    }
  }

  function hide(returnFocus) {
    if (box.hidden) return;
    var r = read();
    if (!r || r.s !== 'subscribed') write('dismissed');
    box.hidden = true;
    document.documentElement.classList.remove('ff-signup-open');
    window.removeEventListener('resize', setLift);
    document.removeEventListener('keydown', onKey);
    if (returnFocus && lastFocus && document.contains(lastFocus) && lastFocus !== document.body) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function setMsg(text, ok) {
    msg.textContent = text;
    msg.className = 'ff-signup__msg ' + (ok ? 'ff-signup__msg--ok' : 'ff-signup__msg--error');
  }

  function success() {
    write('subscribed');
    box.classList.add('ff-signup--done');
    setMsg('Thanks for signing up! Watch your inbox for new arrivals.', true);
    setLift();
    try { box.focus({ preventScroll: true }); } catch (e) {}
  }

  closeBtn.addEventListener('click', function () { hide(true); });

  form.addEventListener('submit', function (e) {
    if (!window.fetch || !window.FormData) return; // normal page submit
    if (!input.checkValidity()) return; // let the browser show its message
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    btn.disabled = true;
    setMsg('Signing you up…', true);
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (res) {
        var url = res.url || '';
        if (url.indexOf('customer_posted=true') !== -1) return success();
        if (url.indexOf('/challenge') !== -1) {
          // Shopify spam check needs a real page: submit normally
          btn.disabled = false;
          form.submit();
          return;
        }
        return res.text().then(function (html) {
          btn.disabled = false;
          if (/customer_posted=true|posted_successfully/.test(html)) return success();
          setMsg('Sorry, that didn’t work. Check your email address and try again.', false);
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        });
      })
      .catch(function () {
        btn.disabled = false;
        form.submit();
      });
  });

  // Came back from a normal (non-fetch) submit of this form: show the result.
  if (/[?&]customer_posted=true/.test(location.search) && location.hash === '#FFSignupForm') {
    show({ keepState: true });
    success();
    return;
  }

  if (suppressed()) return;

  // Phones: never on the first page of a visit.
  var isPhone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  var pv = 0;
  try {
    pv = parseInt(sessionStorage.getItem('ff_pv') || '0', 10) + 1;
    sessionStorage.setItem('ff_pv', String(pv));
  } catch (e) { pv = 1; }
  if (isPhone && pv < 2) return;

  function busy() {
    var b = document.body;
    if (b.classList.contains('overflow-hidden') || b.classList.contains('overflow-hidden-mobile') || b.classList.contains('overflow-hidden-tablet')) return true;
    if (document.querySelector('cart-drawer.active, .drawer.active, details.menu-opening, modal-dialog[open], dialog[open], #mao-product-offer-modal[open]')) return true;
    return false;
  }

  function tryShow() {
    if (shown) return;
    if (document.visibilityState === 'hidden' || busy()) {
      clearTimeout(timer);
      timer = setTimeout(tryShow, 5000);
      return;
    }
    show();
  }

  function onScroll() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= 0.5) tryShow();
  }

  function cleanupTriggers() {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  }

  timer = setTimeout(tryShow, 20000);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
